import { createContext, useContext } from 'react';

const GuardedModalCloseContext = createContext<(() => void) | null>(null);

export const GuardedModalCloseProvider = GuardedModalCloseContext.Provider;

export const useGuardedModalClose = (): (() => void) => {
  const requestClose = useContext(GuardedModalCloseContext);

  if (!requestClose) {
    throw new Error('useGuardedModalClose must be used within a GuardedModal');
  }

  return requestClose;
};
